
import React from 'react';

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-50 to-white p-4">
      <div className="w-full max-w-3xl">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Welcome to Smplify</h1>
          <p className="text-lg text-muted-foreground mb-8">
            Your all-in-one device management solution
          </p>
          <p className="mt-4 text-sm text-muted-foreground">
            Please sign in to access your account and manage your devices.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;
